import { Routes, RouterModule } from '@angular/router';
import { AccountSettingsLayoutComponent } from './layout/account-settings-layout.component';
import { AccountSettingsComponent } from './general/account-settings.component';
import { AccountSubscriptionComponent } from './subscription/account-subscription.component';
import { AccountInvoiceComponent } from './invoice/account-invoice.component';
import { AccountTeamComponent } from './team/account-team.component';
import { AccountAuditComponent } from './audit/account-audit.component';

const accountSettingsRoutes: Routes = [
  // Account routes
  {
    path: '',
    //outlet: 'settings',
    component: AccountSettingsLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'general',
        pathMatch: 'full',
      },
      { path: 'general', component: AccountSettingsComponent },
      { path: 'subscription', component: AccountSubscriptionComponent },
      { path: 'invoices', component: AccountInvoiceComponent },
      { path: 'team', component: AccountTeamComponent },
      { path: 'changes', component: AccountAuditComponent },
    ],
  },
];

export const AccountSettingsRouting = RouterModule.forChild(
  accountSettingsRoutes,
);
